import React, { useEffect, useState } from "react";
import Pagination from "@material-ui/lab/Pagination";
// import { upperFirst } from 'lodash'
import { Button, TextField } from "@material-ui/core";
import axios from "axios";
import * as XLSX from "xlsx";
import { ApiURL } from "../constants/ApiUrl";
import axiosInstance from "../services/AxiosInstance";

import "../styles/AdminMembers.css";

function formatMemberOnForExport(value) {
  if (value == null || value === "") return "";
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) return d.toLocaleDateString();
  return String(value);
}

function AdminMembers() {
  const [AppList, setAppList] = useState([]);
  const [Type, setType] = useState("");
  const [searchdata, setSearchdata] = useState("");
  const [data, setData] = useState({});
  const [memberList, setMemberList] = useState([]);

  const [appType, setAppType] = useState(false);

  const [Page, setPage] = useState(0);
  const [TotalPages, setTotalPages] = useState(0);
  const [TotalResult, setTotalResult] = useState(0);
  const [Search, setSearch] = useState("");
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  // var search;
  async function getData(page, limit) {
    // const result =  await axios.get(`${ApiURL}/api/get_members?page=${page}&limit=${limit}&Type=${Type}`);
    if (Type === "old") {
      setAppType(true);
    } else {
      setAppType(false);
    }
    const result = await axiosInstance.get(
      `${ApiURL}/api/searchByDepartment?page=${page}&limit=${limit}&search=${Search}&type=${Type}`
    ); //added Type for search

    setAppList(result.data.data);
    setTotalPages(result.data.totalPages);
    setTotalResult(result.data.totalItems);
  }
  async function searchData(page, limit) {
    console.log("Page & Type", page, Type);
    if (!Search) setSearch("");
    if (!Type) setType("");
    const result = await axiosInstance.get(
      `${ApiURL}/api/searchByDepartment?page=${page}&limit=${limit}&search=${Search}&type=${Type}`
    ); //added Type for search
    // console.log(result.data, "member")
    setAppList(result.data.data);
    setTotalPages(result.data.totalPages);
    setTotalResult(result.data.totalItems);
  }

  // useEffect(() => {
  //     getData(0, 10,);
  //     // setSearch('');
  //     setType('all')
  // }, [])

  // useEffect(() => {
  //     getData(Page, 10);
  // }, [Page, Type])

  useEffect(() => {
    if (Search === "") {
      getData(Page, 50);
      console.log("GetData", Page);
    } else {
      searchData(Page, 50);
      console.log("searchData", Page);
    }
    // eslint-disable-next-line
  }, [Page, Type]);

  const handlePageChange = (e, value) => {
    // console.log(value);

    setPage(value - 1);
    searchData(Page, 50);
  };
  // console.log(AppList, "app")
  const handleView = async (value) => {
    const result = await axios.get(`${ApiURL}/api/get_applications/${value}`);
    const route =
      result.data.data.appType === "student"
        ? `/admin/student/${value}`
        : `/admin/members/${value}`;
    window.open(route, "_blank", "noopener,noreferrer");
  };

  var search = 12;
  const onSearchChange = (e) => {
    // search = e.target.value

    // console.log(e.target.value,'vhvvvvvv')
    // if (e.target.value === '')
    //     getData(0, 10);
    setSearch(e.target.value);
    console.log(Search, "searching");
    // searchData(Page,10)
  };
  // onSearchChange(e)
  // console.log(search, 'outside')
  const onKeyDown = (e) => {
    console.log(e.key);
    if (e.key === "Enter") {
      searchData(Page, 50);
    }
  };
  const handleDownload = async () => {
    const result = await axios.get(`${ApiURL}/api/get_all_members`);
    const rows = (result.data.data || []).map((row) => {
      const raw = row.memberOn ?? row["Member On"];
      const { memberOn, ...rest } = row;
      return {
        ...rest,
        "Member On": formatMemberOnForExport(raw),
      };
    });
    exportToCSV(rows, "Search");
  };
  const downloadData = () => {
    const detailsList = [];
    console.log("Downloading", Search, Type);
    axios
      .get(`${ApiURL}/api/downloadSelectedData?search=${Search}&type=${Type}`)
      .then((res) => {
        res.data.data.forEach((element) => {
          console.log(element.pincode, "pinnnnnnnnn");
          const memberOn =
            new Date(element.expiry_date).getDate() +
            "/" +
            (new Date(element.expiry_date).getMonth() + 1) +
            "/" +
            new Date(element.expiry_date).getFullYear();
          const date =
            new Date(element.dob).getDate() +
            "/" +
            (new Date(element.dob).getMonth() + 1) +
            "/" +
            new Date(element.dob).getFullYear();
          var data = {
            "Membership Number": element.mem_no,
            Name: element.name,
            "Blood Group": element.blood_group,
            "Medical College": element.college,
            "Date of Birth": date,
            Email: element.email,
            Gender: element.gender,
            "Member On": formatMemberOnForExport(element.memberOn),
            "Student Membership Valid Till": memberOn,
            Address: element.address,
            Pincode: element.pincode,
            "Nmo state": element.nmo_state,
            Phone: element.phone,
            Prant: element.prant,
            Qualifications: element.qualifications,
            "Ref. Membership Number": element.ref_membership_no,
            "Ref. Person": element.ref_person,
            "Ref. Person Phone": element.ref_person_phone,
            "Registration Number": element.regno,
            Specialization: element.specialization,
            "State sec Email": element.state_sec_email,
            "Application Fee": element.appFee,
          };
          detailsList.push(data);
        });

        // console.log(detailsList, "listtttt")

        exportToCSV(detailsList, "Search");
      })
      .catch((err) => {
        console.log(err, "fdh");
      });
  };

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    const element = document.createElement("a");
    element.href = URL.createObjectURL(data);
    const dd = new Date();
    element.download = `member-data-backup-${dd.getDate()}-${
      dd.getMonth() + 1
    }-${dd.getFullYear()}.xlsx`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    // FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleSearch = (e) => {
    // setSearch(e.target.value);
    searchData(Page, 50);
    console.log("Handle Search", Search);
  };
  return (
    <>
      <div className="admMem">
        <h1>Member List</h1>
        <div className="searchContainer">
          {/* <h4>Select Member Type</h4> */}
          <select
            className="NewSelects"
            onChange={(e) => setType(e.target.value)}
          >
            <option value="all">Select Member Type</option>
            <option value="all">All</option>
            <option value="life member">Life Member</option>
            <option value="student">Student</option>
            <option value="couple">Couple</option>

            <option value="associate">Associate</option>
            <option value="old">Senior Members</option>
          </select>
          <div
            style={{ width: "50%", gap: "20px" }}
            className="searchContainer"
          >
            <TextField
              style={{ width: "50%" }}
              placeholder="Search"
              label="Degree, Name, State, Member ID"
              onChange={onSearchChange}
              onKeyDown={onKeyDown}
            />
            <Button
              variant="contained"
              style={{ height: "40px" }}
              onClick={handleSearch}
            >
              Search
            </Button>
            <Button
              variant="contained"
              color="secondary"
              style={{ height: "40px" }}
              onClick={downloadData}
            >
              <i class="fa fa-download"></i>
            </Button>
          </div>
          <Button variant="contained" color="primary" onClick={handleDownload}>
            Member Data Download
          </Button>
        </div>
        <Pagination
          count={TotalPages}
          page={Page + 1}
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
        />
        <p>
          <b>{TotalResult} records found.</b>
        </p>
        <table className="appTable">
          <tr>
            <th>S.No</th>
            <th>Membership ID</th>
            <th>Doctor Name</th>
            <th>NMO State</th>
            {/* 22 oct jyoti
                        Remove Medical Degree Field and Added Member since */}
            {/* <th>Medical Degree</th>       // */}
            <th>Member Since</th>
            <th>Action</th>
          </tr>
          {AppList.map((item, index) => (
            <tr key={item.memberID}>
              <td>{Page * 50 + (index + 1)}</td>
              <td>{item.mem_no}</td>
              <td>{item.name}</td>
              <td>{item.nmo_state}</td>
              {/* <td>{(new Date(item.memberOn).getDay())}</td> */}
              <td>
                {item.memberOn
                  ? new Date(item.memberOn).toLocaleDateString()
                  : "—"}
              </td>

              {/* 22 oct jyoti added memberOn date and remove medical degree */}
              {/* <td>{item.qualifications === 'Other' ? item.specialization : item.qualifications}</td> */}
              <td>
                <Button
                  variant="contained"
                  disabled={appType}
                  color="primary"
                  onClick={() => handleView(item.memberID)}
                >
                  View
                </Button>
              </td>
            </tr>
          ))}
        </table>
      </div>
    </>
  );
}

export default AdminMembers;
